/**
 * Clés localStorage du mode maintenance — module FEUILLE, sans aucun import.
 *
 * `useMaintenance` dépend de `auth/api` (authFetch), qui dépend de `auth/useAuth` ; si
 * `useAuth` importait ces clés depuis `useMaintenance`, le cycle ferait exécuter le corps
 * de `useMaintenance` avant celui d'`api.ts` (TDZ sur `maintenanceDetectedListeners`,
 * routeur qui ne démarre pas). Les clés vivent donc ici, hors de tout cycle.
 *
 * Préfixe `ggvie.` : GGVIEChatView peut être monté DANS la sandbox (route /ggvie, même
 * domaine) — pas de collision avec `sapiendo.maintenance.*`.
 */
export const STORAGE_LAST = 'ggvie.maintenance.last'
export const STORAGE_RETURN_TO = 'ggvie.maintenance.returnTo'
